import { EnvType } from '@metadata';

const OP_ENV = window.REACT_APP_OP_ENV || 'local';

const env = (): EnvType => {
  
  if (OP_ENV === 'local') {
    const env: EnvType = {
      BACKEND_API: '/ffis2ai/fdpsapi',
      NGII_KEY: '130ABBD15C3F849A779644F947B8E194',
      NGII_DOMAIN: '/ngii',
      VITE_FOREST_TYPE_IDMD_PATH: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer/0',
      VITE_SLC_ARC_GIS_BASE_URL: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer',
    };

    return env;
  } else if (OP_ENV === 'production') {
    const env: EnvType = {
      BACKEND_API: '/ffis2ai/fdpsapi',
      NGII_KEY: '130ABBD15C3F849A779644F947B8E194',
      NGII_DOMAIN: 'http://10.98.25.94:18080',
      VITE_FOREST_TYPE_IDMD_PATH: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer/0',
      VITE_SLC_ARC_GIS_BASE_URL: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer',
    };

    return env;
  }
  const env: EnvType = {
    BACKEND_API: '/ffis2ai/fdpsapi',
      NGII_KEY: '130ABBD15C3F849A779644F947B8E194',
      NGII_DOMAIN: 'http://10.98.25.94:18080',
      VITE_FOREST_TYPE_IDMD_PATH: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer/0',
      VITE_SLC_ARC_GIS_BASE_URL: 'https://gis.kwater.or.kr/arcgis/rest/services/SLC/SLC/MapServer',
  };

  return env;
};

export default env;
